import $             from "jquery"
import jQueryBridget from "jquery-bridget/jquery-bridget"
import Isotope       from "isotope-layout/dist/isotope.pkgd.min"

jQueryBridget('isotope', Isotope, $);

let filtersContainer;
let filters = {};
let selectedFilters = [];
let comboFilterArr = [];
let hashFilterArr = [];

/**
* Init Isotope
*/
filtersContainer = $('.js-filter-container');

filtersContainer.isotope({
  itemSelector: '.work__filter-item',
  transitionDuration: 0,
  layoutMode: 'fitRows',
  fitRows: {
    equalheight: true
  }
});

filtersContainer.isotope( 'on', 'arrangeComplete', function( filteredItems ) {
  const workItemVisible = $('.work__filter-item:visible').length;
  if(workItemVisible){
    $('.js-work-item-counter-wrapper').addClass('work__counter--display');
    $('.js-work-item-counter').text(workItemVisible);
  }

  setTimeout(function(){
    let currentFilter = '';
    if(selectedFilters.length) {
      currentFilter = selectedFilters[selectedFilters.length - 1];

      let checkbox =  $('.filter__options').find('.filter__options-checkbox[value="'+currentFilter+'"]');
      setFilterButtons(checkbox,filteredItems);
    }else{
      enableAllFilter();
    }
    setCheckAll();
  },500);
});

var initFilterItemsShow = filtersContainer.data('limit') ? parseInt(filtersContainer.data('limit')) : parseInt(6) ; //Number of items loaded on init & onclick load more button
var moreFilterItemsShow = initFilterItemsShow; //Counter for load more button
var iso = filtersContainer.data('isotope'); // Get Isotope instance

loadMoreFilterItems(initFilterItemsShow);

function setCheckAll(){
    let groups = $('.filter__options-set');
    $.each(groups, function(i,g){
      let activeChkBox = $(this).find('.filter__options-checkbox').not(':disabled').length;
      let inputChkBox = $(this).find('.filter__options-checkbox').length;

      if(inputChkBox != activeChkBox){
        $(this).find('.filter__options-all').addClass('disabled');
      }else{
        $(this).find('.filter__options-all').removeClass('disabled');
      }
    });
}

/**
 * Load more filter function
 */
function loadMoreFilterItems(toShow) {
  var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
    return item.element;
  });
  var comboFilter = getComboFilter( filters );

  filtersContainer.find(".is-hidden").removeClass("is-hidden");

  $(hiddenElems).addClass('is-hidden');

  filtersContainer.isotope({
    filter: comboFilter,
    transitionDuration: 0,
    layoutMode: 'fitRows',
    fitRows: {
      equalheight: true
    }
  });

  //When no more to load, hide show more button
  if (hiddenElems.length == 0) {
    $(".js-load-more-filter-items").hide();
  } else {
    $(".js-load-more-filter-items").show();
  };

  if(!iso.filteredItems.length){
    $('.filter__none').show();
  }else{
    $('.filter__none').hide();
  }
}

/**
 * isMobileDevice() Function to detect if the device is a mobile device
 * detectDevice() Function to handle device detection on load and resize
 */
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

function detectDevice() {
  if (isMobileDevice()) {
      $('body').removeClass('body--desktop');
  } else {
      $('body').addClass('body--desktop');
  }
}

detectDevice();

window.addEventListener('resize', detectDevice);

/**
 * Load more filter button append
 */
filtersContainer.after('<span class="filter__more js-load-more-filter-items"></span>');

/**
 * Load more button click
 */
$(".js-load-more-filter-items").on('click', function() {
  moreFilterItemsShow = moreFilterItemsShow + initFilterItemsShow;
  loadMoreFilterItems(moreFilterItemsShow);
});

/**
 * Load more button auto load
 */
$(window).on('scroll', function() {
  var hT = $('.js-load-more-filter-items').offset().top,
      hH = $('.js-load-more-filter-items').outerHeight(),
      wH = $(window).height(),
      wS = $(this).scrollTop();

  if (wS > (hT+hH-wH)){
      if($('.js-load-more-filter-items:visible').length){
        $(".js-load-more-filter-items").trigger('click'); 
      }
  }

  // Fixed filter section
  if (sectionIndicatorId() == 'work-filter'){
    $('.js-filter-section').addClass('filter--fixed');
  }else{
    $('.js-filter-section').removeClass('filter--fixed');
  }
});

/**
 * Filter checkbox on change
 */
$('.js-filter-options').on( 'change', function( jQEvent ) {
  var $checkbox = $( jQEvent.target );
  manageCheckbox( $checkbox );

  var comboFilter = getComboFilter( filters );

  if(!$($checkbox).is(':checked')){
    const index = selectedFilters.indexOf($checkbox.val());
    if (index > -1) { // only splice array when item is found
      selectedFilters.splice(index, 1); // 2nd parameter means remove one item only
    }
  }else{
    selectedFilters.push($checkbox.val());
  }
  
  filtersContainer.isotope({
    filter: comboFilter,
    transitionDuration: 0,
    layoutMode: 'fitRows',
    fitRows: {
      equalheight: true
    }
  });

  loadMoreFilterItems(initFilterItemsShow, $checkbox);
});

/**
 * Check for section indicator to handle fixed filter section when scroll is reached on work items section
 */
function sectionIndicatorId(){
  const sectionIndicatorArr = [];

  $('.page-template-our-work .section__indicator').each(function(){
      const distanceSection = $(this).offset().top + $('.header').outerHeight();
      const windowElem = $(window);
      const sectionIndicatorId = $(this).attr('id');

      if(windowElem.scrollTop() >= distanceSection ) {
          if (!sectionIndicatorArr.includes(sectionIndicatorId)) {
              sectionIndicatorArr.push(sectionIndicatorId);
          }
      }
  });

  return sectionIndicatorArr[sectionIndicatorArr.length - 1];
}

function setFilterButtons(checkbox, filteredItems){
    let currentSelected = checkbox;
    let currentDataGroup = currentSelected.closest('.filter__options-set').data('group');
    let currentSelectedFilter = currentSelected.val();

    
    comboFilterArr.push(currentSelectedFilter);
    let groups = $('.filter__options .filter__options-set:not(.' + currentDataGroup + ')');
    /*
    * groups: industry, services, solution, technologies
    * */

    $.each(groups, function(){
      let checkboxes = $(this).find('.filter__options-checkbox:not(:checked)');
      $.each(checkboxes, function (k, $checkbox) {
        var filterValue = $($checkbox).val();
        filterValue = filterValue.replace('.', '');
        /* Check each item if current checkbox has value.*/
        var hasResults = filteredItems.some(function(item) {
          return $($(item)[0].element).hasClass(filterValue);
        });

        if (hasResults) {
          /*enable filter*/
          $($checkbox).prop('disabled', false);
          $($checkbox).closest('.filter__options-inner').find('.filter__options-label').removeClass('disabled');
        } else {
          $($checkbox).prop('disabled', true);
          $($checkbox).closest('.filter__options-inner').find('.filter__options-label').addClass('disabled');
        }
      });
    });
}

function enableAllFilter(){
  $('.filter__options .filter__options-checkbox').not(':checked').prop('disabled',false);
  $('.filter__options .filter__options-label').removeClass('disabled');
}


/**
 * Filter clear
 */
$('.js-filter-clear').on('click', function(){
  loadMoreFilterItems(initFilterItemsShow);

  $('.filter__options-checkbox').each(function(){
    if( $(this).is(':checked') ){
      $(this).trigger('click');
    }
  });
});

function getComboFilter( filters ) {
  var i = 0;
  var comboFilters = [];
  var message = [];

  for ( var prop in filters ) {
    message.push( filters[ prop ].join(' ') );
    var filterGroup = filters[ prop ];
    // Skip to next filter group if it doesn't have any values
    if ( !filterGroup.length ) {
      continue;
    }
    if ( i === 0 ) {
      // Copy to new array
      comboFilters = filterGroup.slice(0);
    } else {
      var filterSelectors = [];
      // copy to fresh array
      var groupCombo = comboFilters.slice(0);
      // merge filter Groups
      for (var k=0, len3 = filterGroup.length; k < len3; k++) {
        for (var j=0, len2 = groupCombo.length; j < len2; j++) {
          filterSelectors.push( groupCombo[j] + filterGroup[k] );
        }
      }
      // apply filter selectors to combo filters for next group
      comboFilters = filterSelectors;
    }
    i++;
  }

  var comboFilter = comboFilters.join(', ');
  return comboFilter;
}

function manageCheckbox( $checkbox ) {
  var checkbox = $checkbox[0];
  var group = $checkbox.parents('.filter__options-set').attr('data-group');

  // create array for filter group, if not there yet
  var filterGroup = filters[ group ];

  if ( !filterGroup ) {
    filterGroup = filters[ group ] = [];
  }

  var isAll = $checkbox.hasClass('all');
  // reset filter group if the all box was checked
  if ( isAll ) {
    delete filters[ group ];
    if ( !checkbox.checked ) {
      checkbox.checked = 'checked';
    }
  }
  // index of
  var index = $.inArray( checkbox.value, filterGroup );

  if ( checkbox.checked ) {
    var selector = isAll ? 'input' : 'input.all';
    $checkbox.siblings( selector ).removeAttr('checked');

    if ( !isAll && index === -1 ) {
      // add filter to group
      filters[ group ].push( checkbox.value );
    }
  } else if ( !isAll ) {
    // remove filter from group
    filters[ group ].splice( index, 1 );
    // if unchecked the last box, check the all
    if ( !$checkbox.siblings('[checked]').length ) {
      $checkbox.siblings('input.all').attr('checked', 'checked');
    }
  }
}

/**
 * Script for filter dropdown base on ticket's goal
 */
$('.filter__choosen').on('click', function() {
  const accordionItem = $(this).parent('.filter__options-set');
  const accordionContent = accordionItem.children('.filter__options-list');
  const accordionChoosen = accordionItem.children('.filter__choosen');
  const accordionOptionOverlay = accordionItem.closest('.filter__options-set').find('.js-options-set-overlay');
  
  if (accordionContent.is(':visible')) {
    accordionContent.removeClass('is-visible');
    accordionChoosen.removeClass('is-choosen');
  } else {
    $('.filter__options-list').removeClass('is-visible');
    $('.filter__choosen').removeClass('is-choosen');
    accordionOptionOverlay.addClass('filter__options-overlay--active');
    accordionContent.addClass('is-visible');
    accordionChoosen.addClass('is-choosen');
  }
});

$(document).on('mouseup', function (e){
  const filterSelect = $(".body--desktop .filter__options-list");

  if (!filterSelect.is(e.target) && filterSelect.has(e.target).length === 0){
    $('.body--desktop .filter__options-list').removeClass('is-visible');
    $('.body--desktop .filter__choosen').removeClass('is-choosen');
    $('.js-options-set-overlay').removeClass('filter__options-overlay--active');
  }
}); 

$('.js-options-set-overlay').each(function(){
  $(this).on('click', function(){
    $(this).removeClass('filter__options-overlay--active');
    $('.body--desktop .filter__options-list').removeClass('is-visible');
    $('.body--desktop .filter__choosen').removeClass('is-choosen');
  });
});

$('.filter__options-set').each(function(){
  let workFilterValueArr = [];

  $(this).find('.filter__options-checkbox').each(function(){
    const filterCheckbox = $(this);

    filterCheckbox.on('change', function(){
      const filterValue = $(this).closest('.filter__options-inner').find('.filter__options-label').text().trim();
      const filterCheckedLength = $(this).closest('.filter__options-list').find('.filter__options-checkbox').filter(':checked').length;
      const filterLabel = $(this).closest('.filter__options-set').find('.filter__choosen-value');
      const filterChecked = $(this).is(':checked');
      const filterOptionsListClearFilter = $(this).closest('.filter__options-list').find('.filter__options-clear');

      // Store checkbox value in an array and store unique values only
      if(filterChecked){
        if (!workFilterValueArr.includes(filterValue)) {
          workFilterValueArr.push(filterValue);
        }
      }else{
        workFilterValueArr.splice(workFilterValueArr.indexOf(filterValue), 1);
      }

      // Filter label change
      if(filterCheckedLength){
        filterLabel.text(workFilterValueArr[0]);
        filterOptionsListClearFilter.addClass('filter__options-clear--visible');
        $(this).closest('.filter__options-list').prev().find('.js-choosen-filter-clear').addClass('d-inline-block');

        if(filterCheckedLength > 1){
          filterLabel.append('<span class="filter__choosen-counter">' + parseInt(filterCheckedLength - 1) + '</span>');
        }else{

        }
      }else{
        filterLabel.text('All');
        filterOptionsListClearFilter.removeClass('filter__options-clear--visible');
        $(this).closest('.filter__options-list').prev().find('.js-choosen-filter-clear').removeClass('d-inline-block');
      }

      if( !filterCheckbox.is(':checked') ){
        $('.all-inner').removeClass('is-all-checked');
      }

      // Show "Clear Filter" button when there is a filter selected
      const checkBoxesAll = $('.filter__options-checkbox:checked');

      if(checkBoxesAll.length){
        $('.filter__clear').removeClass('filter__clear--inactive');
        $('.section.section--work').addClass('overlay-active');
        $('.js-clear-count').text(checkBoxesAll.length);
      }else{
        $('.filter__clear').addClass('filter__clear--inactive');
        $('.section.section--work').removeClass('overlay-active');
      }

      if($('.js-filter-mobile-trigger').hasClass('filter__mobile--expand')){
        $('html, body').animate({
          scrollTop: $("#work-filter").offset().top + 10
        }, 100);
      }
    });
  });
});

$('.js-choosen-filter-clear, .js-option-clear-list').each(function(){
  $(this).on('click', function(){
    $(this).closest('.filter__options-set').find('.filter__options-checkbox:checked').trigger('click');
  });
});

$('.js-filter-options-all').each(function(){
  $(this).on('click', function(){
    let isDisabled = $(this).closest('.filter__options-all');
    if(!isDisabled.hasClass('disabled')){
      $(this).closest('.all-inner').addClass('is-all-checked');
      $(this).closest('.filter__options-list').find('.filter__options-checkbox').not(':checked').trigger('click');
    }
  });
});

$('.js-filter-options-all-clear').each(function(){
  $(this).on('click', function(){
    $(this).closest('.all-inner').removeClass('is-all-checked');

    if($(this).closest('.filter__options-list').find('.filter__options-checkbox').is(':checked')){
      $(this).closest('.filter__options-list').find('.filter__options-checkbox').trigger('click');
    }
  });
});

/**
 * Add hash on url when doing filter
 */
$('.filter__options-checkbox').each(function(){
  $(this).each(function(){
    const filterCheckbox = $(this);

    filterCheckbox.on('change', function(){
      const filterValue = $(this).data('filter');
      const filterChecked = $(this).is(':checked');

      if(filterChecked){
        if (!hashFilterArr.includes(filterValue)) {
          hashFilterArr.push(filterValue);
        }
      }else{
        hashFilterArr.splice(hashFilterArr.indexOf(filterValue), 1);
      }

      if (history.pushState) {
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?filter=' + hashFilterArr;

        if(!hashFilterArr.length){
          newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        }

				window.history.pushState({path:newurl},'',newurl);
			}
    });
  });
});

$(window).on('load', function(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const hashFilterQueryString = urlParams.get('filter');

  if(hashFilterQueryString){
    const hashFilterQueryArr = hashFilterQueryString.split(',');

    $('.filter__options-checkbox').each(function(){
      const filterOptionCheckboxDataFilter = $(this).data('filter');

      if($.inArray(filterOptionCheckboxDataFilter, hashFilterQueryArr) != -1){
        $(this).trigger('click');
      }
    });
  }

  // Check if all option checkbox on a set is checked
  $('.filter__options-set').each(function(){
    const filterOptionCheckbox = $(this).find('.filter__options-checkbox');
    const filterOptionCheckboxChecked = $(this).find('.filter__options-checkbox:checked');

    if(filterOptionCheckbox.length == filterOptionCheckboxChecked.length){
      $(this).closest('.filter__options-set').find('.all-inner-label').trigger('click');
    }
  });
});

/**
 * Mobile viewport filter behavior scripts
 */
$('.js-filter-mobile-trigger').on('click', function(){
  $('.filter__options').toggle();
  $('.section.section--work').toggleClass('expanded');
  $('body').toggleClass('is-o-hidden');
  $(this).toggleClass('filter__mobile--expand');
});

$(document).on('click', '.js-filter-mobile-trigger.filter__mobile--expand', function(){
  $('html, body').animate({
    scrollTop: $("#work-filter").offset().top + 10
  }, 100);
});

$(document).on('mouseup', function (e){
    var container = $(".section.section--filter"); // Give you class or ID
    
    if (!container.is(e.target) &&            // If the target of the click is not the desired div or section
        container.has(e.target).length === 0) // ... nor a descendant-child of the container
    {
      $('.filter__options').hide();
      $('.filter__options-list').removeClass('is-visible');
      $('.filter__choosen').removeClass('is-choosen');
      $('.section.section--work').removeClass('expanded');
      $('.js-filter-mobile-trigger').removeClass('filter__mobile--expand');
      $('body').removeClass('is-o-hidden');
    }
});